<template>
  <div class="auth-wall">
    <LoginView
      v-if="!isLoggedIn"
      :newRoute="route.fullPath"
    />
    <slot v-else />
  </div>
</template>

<script setup>
import { inject, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import LoginView from '@/components/objects/user/LoginView.vue'

const userStore = inject('userStore')
const { userData } = storeToRefs(userStore)
const route = useRoute()

const isLoggedIn = computed(() => !!userData.value)
</script>

<style scoped src="@/assets/styles/sfc/components/modules/AuthWall.css"></style>
